<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
			:busConfigurations="busConfigurations"
      simulationLabel="ViessmannVitotrans353VT2_2d00_4erKaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ViessmannVitotrans353VT2 from '@/device-products/ViessmannVitotrans353VT2.vue';
import DdsSensor from '@/device-products/DdsSensor.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    {
        label: 'GP',
        connections: [
            {
                id: 'Station 1 zu Station 2',
                from: { deviceId: 0, uart: 0},
                to: { deviceId: 2, uart: 0},
            }, {
                id: 'Station 2 zu Station 3',
                from: { deviceId: 2, uart: 0},
                to: { deviceId: 4, uart: 0},
            }, {
                id: 'Station 3 zu Station 4',
                from: { deviceId: 4, uart: 0},
                to: { deviceId: 6, uart: 0},
            }]
    },{
        label: 'DDS',
        connections: [
          {
            id: 'Station 1 zu DDS 1',
            from: { deviceId: 0, uart: 1},
            to: { deviceId: 1, uart: 0},
          },
          {
            id: 'Station 2 zu DDS 2',
            from: { deviceId: 2, uart: 1},
            to: { deviceId: 3, uart: 0},
          },
          {
            id: 'Station 3 zu DDS 3',
            from: { deviceId: 4, uart: 1},
            to: { deviceId: 5, uart: 0},
          },
          {
            id: 'Station 4 zu DDS 4',
            from: { deviceId: 6, uart: 1},
            to: { deviceId: 7, uart: 0},
          }
        ],
    }],
    simulationDevices: [
      { id: 0, component: ViessmannVitotrans353VT2, deviceLabel: "Station 1 - Master" },
      { id: 1, component: DdsSensor, deviceLabel: 'Volumenstromsensor', deviceColor: 'green', props: {
        defaultSensorType: 'Allengra',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 0.0 },
        ],
      }},
      { id: 2, component: ViessmannVitotrans353VT2, deviceLabel: "Station 2" },
      { id: 3, component: DdsSensor, deviceLabel: 'Volumenstromsensor', deviceColor: 'green', props: {
        defaultSensorType: 'Allengra',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 0.0 },
        ],
      }},
      { id: 4, component: ViessmannVitotrans353VT2, deviceLabel: "Station 3" },
      { id: 5, component: DdsSensor, deviceLabel: 'Volumenstromsensor', deviceColor: 'green', props: {
        defaultSensorType: 'Allengra',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 0.0 },
        ],
      }},
      { id: 6, component: ViessmannVitotrans353VT2, deviceLabel: "Station 4" },
      { id: 7, component: DdsSensor, deviceLabel: 'Volumenstromsensor', deviceColor: 'green', props: {
        defaultSensorType: 'Allengra',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 0.0 },
        ],
      }}
    ],
  }),
};
</script>

<style>
</style>
